import { makeStyles } from '@rbx/ui';

const useBotAlertStyles = makeStyles()((theme) => ({
  alert: {
    margin: theme.spacing(3, 0),
    fontSize: 16,
    '& a': {
      color: 'inherit',
      textDecorationColor: 'inherit',
      textDecoration: 'underline',
    },
  },
}));

export default useBotAlertStyles;
